import "../tokens.css"
import { statusStyle, statusLabel as defaultLabel } from "../tokens"

export const StatusPill = ({ status, label, tone }) => {
  const colors = tone
    ? {
        success: { fg: "#0E7A57", bg: "#E6F5F0" },
        warning: { fg: "#B45309", bg: "#FEF3E2" },
        info: { fg: "#1D4ED8", bg: "#E8EFFE" },
        danger: { fg: "#B42318", bg: "#FEECEA" },
        neutral: { fg: "#475467", bg: "#F2F4F7" },
      }[tone]
    : statusStyle(status)
  const text = label || defaultLabel(status)
  return (
    <span className="ds-pill" style={{ background: colors.bg, color: colors.fg }}>
      <span className="ds-pill-dot" aria-hidden />
      {text}
    </span>
  )
}

export default StatusPill
